export default __webpack_public_path__ + "static/media/mountain.222eb45f.ogg";